<template lang="pug">
Vip(:back='Vip', onBack:='onBack')
</template>

<script>
import Vip from '@/UIO/Vip'
export default {
  name: 'NoPain',
  components: { Vip },
  props: ['back', 'onBack']
}
</script>



// WEBPACK FOOTER //
// src/screens/vip/index.vue